import { ImportExportRounded, KeyboardArrowDown } from '@mui/icons-material'
import { Button } from '@mui/material'
import { Trans } from 'react-i18next'

type SortButtonProps = {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  sortName:
    | 'asc_created'
    | 'desc_created'
    | 'by_name'
    | 'asc_opened'
    | 'by_popularity'
    | 'desc_opened'
    | 'asc_upcoming'
    | 'desc_upcoming'
    | 'desc_like'
    | 'asc_comment_created'
    | 'asc_added'
    | 'desc_added'
}

export function SortButton({ sortName, onClick }: SortButtonProps): JSX.Element {
  return (
    <Button
      size='small'
      color='inherit'
      variant='outlined'
      startIcon={<ImportExportRounded />}
      endIcon={<KeyboardArrowDown />}
      onClick={onClick}
      style={{
        minHeight: 32,
        whiteSpace: 'nowrap',
      }}
    >
      <Trans i18nKey={sortName} />
    </Button>
  )
}
